import { render, staticRenderFns } from "./StoryEditorAttachments.vue?vue&type=template&id=5dc69924&scoped=true&"
import script from "./StoryEditorAttachments.vue?vue&type=script&lang=js&"
export * from "./StoryEditorAttachments.vue?vue&type=script&lang=js&"
import style0 from "./StoryEditorAttachments.vue?vue&type=style&index=0&id=5dc69924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc69924",
  null
  
)

export default component.exports